import DOMPurify from 'dompurify'
import validator from 'validator'

export const sanitizeHTML = (html) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br'],
    ALLOWED_ATTR: ['href']
  })
}

export const sanitizeEmail = (email) => {
  return validator.isEmail(email) ? validator.normalizeEmail(email) : null
}

export const sanitizeText = (text) => {
  if (!text) return ''
  return validator.escape(text)
}

export const sanitizeFileName = (filename) => {
  return filename.replace(/[^a-zA-Z0-9.-]/g, '_')
}
